import {
    getSelectedCover,
    getCustomerIdValue,
    getVehicleRecordIdValue,
    getInsuranceQuotationIdValue,
    getQuoteForm,
} from '../../../selectors/ugMotorInsurance/quote';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';
import { getCarDetailsForm } from '../../../selectors/ugMotorInsurance/carDetails';

export const submitCarDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const state = store.getState();

                const selectedCover = getSelectedCover(state);

                let resp;

                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await makeComprehensiveSubmission(state);

                    if (resp.data) {
                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await makeThirdPartySubmission(state);

                    if (resp.data) {
                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const comprehensivePayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);
    const vehicleRecordId = getVehicleRecordIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const carDetails = getCarDetailsForm(state);
    const quotation = getQuoteForm(state);

    const carDetailsPayload = {
        insurance_id: customerId.value,
        quotation_id: insuranceQuotationId.value,
        vehicle_id: vehicleRecordId.value,
        make: parseInt(quotation.carMake.value.id) || parseInt(quotation.carModel.value.id),
        model: parseInt(quotation.carModel.value.id),
        registrationNumber: carDetails.registrationNumber.value ? carDetails.registrationNumber.value : 'N/A',
        chassisNumber: carDetails.chasisNumber.value ? carDetails.chasisNumber.value : 'N/A',
        engineNumber: carDetails.engineNumber.value ? carDetails.engineNumber.value : 'N/A',
        sittingCapacity: carDetails.sittingCapacity.value ? parseInt(carDetails.sittingCapacity.value) : 0,
        fuel: carDetails.fuel.value ? carDetails.fuel.value : 'N/A',
        bodyType: carDetails.bodyType.value ? carDetails.bodyType.value : 'N/A',
        color: carDetails.color.value ? carDetails.color.value : 'N/A',
        yearsWithLicense: carDetails.yearsWithLicense.value ? parseInt(carDetails.yearsWithLicense.value) : 0,
    };

    return {
        ...carDetailsPayload,
    };
};

const makeComprehensiveSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/vehicle-details';

        return await axios.post(url, comprehensivePayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const thirdPartyPayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);
    const quotation = getQuoteForm(state);

    const carDetails = getCarDetailsForm(state);

    const carDetailsPayload = {
        id: customerId.value,
        make: parseInt(quotation.carMake.value.id) || parseInt(quotation.carModel.value.id),
        model: parseInt(quotation.carModel.value.id),
        registrationNumber: carDetails.registrationNumber.value ? carDetails.registrationNumber.value : 'N/A',
        chassisNumber: carDetails.chasisNumber.value ? carDetails.chasisNumber.value : 'N/A',
        engineNumber: carDetails.engineNumber.value ? carDetails.engineNumber.value : 'N/A',
        sittingCapacity: carDetails.sittingCapacity.value ? parseInt(carDetails.sittingCapacity.value) : 0,
        use: quotation.carUse.value,
        fuel: carDetails.fuel.value ? carDetails.fuel.value : 'N/A',
        bodyType: carDetails.bodyType.value ? carDetails.bodyType.value : 'N/A',
        color: carDetails.color.value ? carDetails.color.value : 'N/A',
        yearsWithLicense: carDetails.yearsWithLicense.value ? parseInt(carDetails.yearsWithLicense.value) : 0,
        yearOfManufacture: quotation.yearOfManufacture.value,
    };

    return {
        ...carDetailsPayload,
    };
};

const makeThirdPartySubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/third-party/vehicle-details';

        return await axios.post(url, thirdPartyPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
